import { isSSR } from './ssr';

export const fileDownload = (fileName: string, data: unknown) => {
  if (isSSR) {
    return;
  }
  const blobData = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  });
  const url = window.URL.createObjectURL(blobData);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName as string;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export const localFileDownload = async (fileName: string, url: string) => {
  if (isSSR) {
    return;
  }

  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to download file');

  const blob = await res.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  a.setAttribute('download', fileName);
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();

  // cleanup
  window.URL.revokeObjectURL(blobUrl);
};
